import { ChevronRightRounded } from "@material-ui/icons";
import Parser from "../utils/parser";
import Button from "./Button";
import ListItem from "./ListItem";
import Text from "./Text";
import { useState } from "react";

export default function FAQ({ config }) {
  return (
    <div className={"faq-section " + config.mode || 'DARK'} id="faq">
      <Text
        config={{
          variant: "H2",
          color: "light",
          text: config.settings.title,
        }}
      />

      <div className="faq-answers-area">
        {config.settings.questions?.map((item, index) => (
          <>
            {index !== 0 && <span className="divider"></span>}
            <Question info={item} key={"list-item-" + index} />
          </>
        ))}
      </div>
    </div>
  );
}

function Question({ info }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={"question-box " + (open ? "open" : "")}>
      <div onClick={() => setOpen(!open)} className="question-title">
        <Text
          config={{
            variant: "H4",
            color: "light",
            text: info.title,
          }}
        />
        <ChevronRightRounded style={{ color: "white" }} />
      </div>
      {open && (
        <div className="question-answer">
          <Text
            config={{
              variant: "P",
              color: "light",
              text: info.answer,
            }}
          />
        </div>
      )}
    </div>
  );
}
